export default __webpack_public_path__ + "assets/icons/document.97bec6f6.svg";